/*
  Máscara de telefone brasileiro nos formulários do tema: "(54) 99606-2551" enquanto a pessoa digita.
  Vale para todo <input data-phone-mask> da página (cadastro do modelo 3D, parceiros, página corporativa).
  Aceita fixo com 8 dígitos ("(54) 3055-4353") e número colado com +55 (o código do país sai).
  Ao apagar, a máscara não se refaz no meio do caminho (o separador não trava o backspace); volta ao sair do campo.
*/
(() => {
  if (window.inusualPhoneMask) return;
  window.inusualPhoneMask = true;

  const format = (value) => {
    let digits = value.replace(/\D/g, '');
    if (digits.length > 11 && digits.startsWith('55')) digits = digits.slice(2);
    digits = digits.slice(0, 11);
    if (!digits) return '';
    if (digits.length <= 2) return `(${digits}`;
    const area = digits.slice(0, 2);
    const number = digits.slice(2);
    if (number.length <= 4) return `(${area}) ${number}`;
    const cut = number.length > 8 ? 5 : 4;
    return `(${area}) ${number.slice(0, cut)}-${number.slice(cut)}`;
  };

  const masked = (target) => target instanceof HTMLInputElement && target.hasAttribute('data-phone-mask');

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!masked(input) || event.inputType?.startsWith('delete')) return;
    // O cursor fica depois do mesmo número de dígitos de antes (digitar no meio do número não pula para o fim).
    const caret = input.selectionStart ?? input.value.length;
    const digitsBefore = input.value.slice(0, caret).replace(/\D/g, '').length;
    input.value = format(input.value);
    let position = 0;
    for (let seen = 0; position < input.value.length && seen < digitsBefore; position++) {
      if (/\d/.test(input.value[position])) seen++;
    }
    input.setSelectionRange(position, position);
  });

  document.addEventListener('focusout', (event) => {
    if (masked(event.target)) event.target.value = format(event.target.value);
  });

  // Valor que já vem preenchido (telefone da conta, "+5554996062551") entra no mesmo formato.
  document.querySelectorAll('input[data-phone-mask]').forEach((input) => {
    if (input.value) input.value = format(input.value);
  });
})();
